export default "__VITE_ASSET__D63n8_IT__"